import UserAvatar from "components/User/UserAvatar";
import moment from "moment";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { PUBLIC_ROUTES } from "routes/routes";
import { IActivity } from "types/Activitites.type";

interface IEventCardProps extends IActivity {}

const EventCard = (props: IEventCardProps) => {
  const { name, images, invitedUsers, startDate, slug } = props;
  const router = useRouter();

  const avatarToShow: number = 3;

  const handleOpenEvent = () => {
    router.push(PUBLIC_ROUTES.activityPage.path.replace("[slug]", slug));
  };

  return (
    <div
      className="animate__animated animate__fadeIn relative m-0 mb-3 cursor-pointer rounded-xl p-0"
      onClick={handleOpenEvent}
    >
      <div
        className="relative m-0 rounded-xl p-0 shadow-lg"
        style={{ borderRadius: "1rem", height: "380px", width: "268px" }}
      >
        <Image
          src={images?.[0] ?? "https://picsum.photos/600/600"}
          quality={100}
          layout="fill"
          objectFit="cover"
          className="absolute rounded-xl"
          alt="Event image"
        />
        <div
          className="absolute flex flex-col justify-end rounded-xl bg-black/50"
          style={{ borderRadius: "1rem", height: "380px", width: "268px" }}
        >
          <div className="absolute top-0 flex w-full items-center justify-between p-2 text-white">
            <div className="flex items-center">
              {invitedUsers?.length >= 1 &&
                invitedUsers?.slice(0, avatarToShow).map((invitedUser) => (
                  <div
                    key={`${invitedUser.id}_${Math.random()}`}
                    className="mr-2"
                    style={{ width: 30, height: 30 }}
                  >
                    <UserAvatar user={invitedUser} showName={false} size={26} />
                  </div>
                ))}
              {invitedUsers?.length > avatarToShow && (
                <div
                  className="flex items-center justify-center rounded-full border-2 border-white bg-current-500 font-bold"
                  style={{
                    width: 26,
                    height: 26,
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  +{invitedUsers.length - avatarToShow}
                </div>
              )}
            </div>
            <div className="flex flex-col items-center">
              <span className="text-lg font-bold">
                {moment(startDate).format("DD")}
              </span>
              <span className="text-xs">
                {moment(startDate).format("MMM").toUpperCase()}
              </span>
            </div>
          </div>
          <div className="flex h-1/3 items-center rounded-b-lg bg-black/70 p-3">
            <h3 className="text-xl font-bold text-white">{name}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EventCard;
